/** 手机使用要求：操作组可换行，表单在窄屏按单列阅读；不改变既有权限、数据与审批规则。 */
import React, { useState } from "react";
import { useApp } from "../../context/AppContext";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { SignaturePad } from "../ui/signature-pad";
import { toast } from "../ui/sonner";
import { CheckCircle2, Loader2 } from "lucide-react";

/* 员工签收设备：手写签名 → POST /ack {signature} */
export function AckSignDialog({ zh, asset, onClose, onDone }) {
  const { api } = useApp();
  const T = (z, e) => (zh ? z : e);
  const [sig, setSig] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    if (!sig) return toast.error(T("请先手写签名", "Please sign first"));
    setBusy(true);
    try {
      await api.post(`/finance/fixed-assets/${asset.id}/ack`, { signature: sig });
      toast.success(T(`已签收 ${asset.name}`, "Acknowledged"));
      onDone?.(); onClose();
    } catch (e) { toast.error(e?.response?.data?.detail || e.message); }
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={onClose}><DialogContent className="max-w-md" data-testid="asset-ack-dialog">
      <DialogHeader><DialogTitle>{T("签收确认", "Acknowledge receipt")}</DialogTitle>
        <DialogDescription><span className="font-semibold text-slate-700">{asset.name}</span> · {asset.id}{asset.serialNo ? ` · SN ${asset.serialNo}` : ""}</DialogDescription></DialogHeader>
      <p className="text-xs text-slate-500 rounded-lg bg-slate-50 border border-slate-200 px-3 py-2" data-testid="asset-ack-terms">{T("本人确认已收到上述公司设备，承诺妥善保管、仅用于工作用途；离职或调岗时按原状归还。", "I confirm receipt of the above company equipment and agree to return it in good condition upon separation or transfer.")}</p>
      <SignaturePad zh={zh} onChange={setSig} testid="asset-ack-signature" />
      <div className="flex-wrap md:flex-nowrap flex justify-end gap-2"><Button variant="outline" onClick={onClose}>{T("取消", "Cancel")}</Button>
        <Button data-testid="asset-ack-submit" disabled={busy || !sig} className="bg-emerald-600 hover:bg-emerald-700 gap-1.5" onClick={submit}>{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <CheckCircle2 className="h-4 w-4" />}{T("签名并确认已收到", "Sign & confirm")}</Button></div>
    </DialogContent></Dialog>
  );
}
